import { Text, Table, Thead, Tbody, Th, Tr, Td } from '@chakra-ui/react';
import * as lodash from 'lodash';
import React from 'react';

import { Deliverable } from '@finley-technologies/finley-types';

import { StickyHeaderSection } from 'packages/common-frontend/components/StickyHeaderSection';

const { isEmpty: _isEmpty, join: _join, map: _map } = lodash;

type ReportingDeliverablesProps = {
  reportingDeliverables: {
    name: string;
    description?: string;
    section?: string;
    value: Deliverable.v3DEPRECATED.DeliverableValueType;
    fileTypes?: string[];
  }[];
};
export const ReportingDeliverables = ({
  reportingDeliverables,
}: ReportingDeliverablesProps) => {
  return (
    <StickyHeaderSection labelText="Reporting Deliverables">
      {_isEmpty(reportingDeliverables) && (
        <Text>No reporting deliverables have been configured</Text>
      )}
      {!_isEmpty(reportingDeliverables) && (
        <Table>
          <Thead>
            <Tr>
              <Th>Name</Th>
              <Th>Description</Th>
              <Th>Section</Th>
              <Th>Submission Type</Th>
              <Th>Allowed File Types</Th>
            </Tr>
          </Thead>
          <Tbody>
            {_map(
              reportingDeliverables,
              ({ name, description, section, value, fileTypes }) => (
                <Tr key={name}>
                  <Td>{name}</Td>
                  <Td>{description || '-'}</Td>
                  <Td>{section || '-'}</Td>
                  <Td>{value}</Td>

                  <Td>
                    <Text>
                      {fileTypes ? _join(fileTypes, ', ') || '-' : 'N/A'}
                    </Text>
                  </Td>
                </Tr>
              ),
            )}
          </Tbody>
        </Table>
      )}
    </StickyHeaderSection>
  );
};
